module.exports = "<!-- Page Wrapper -->\n<div class=\"page-wrapper\">\n\n  <app-nav></app-nav>\n\n  <section class=\"container-fluid padding-top-3x padding-bottom-3x\">\n\n    <spinner-component></spinner-component>\n\n    <alert></alert>\n\n    <router-outlet></router-outlet>\n\n  </section><!-- .container-fluid.padding-top-3x.padding-bottom-3x -->\n\n  <app-footer></app-footer>\n\n</div><!-- .page-wrapper -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/app.component.html
// module id = ./src/app/Templates/app.component.html
// module chunks = main